import React from 'react';
import Container from '../layout/Container';
import Eyebrow from '../ui/Eyebrow';
import { partners } from '../../data/partners';
import { colors } from '../../lib/tokens';

export default function PartnerStripSection() {
  return (
    <section
      id="partners"
      className="kc-section-compact"
      style={{
        background: colors.surface,
        borderTop: `1px solid ${colors.hair}`,
      }}
    >
      <Container>
        <div data-reveal className="grid grid-cols-1 md:grid-cols-[1fr_3fr] gap-8 md:gap-14 items-center">
          <Eyebrow>Backed by</Eyebrow>
          <div
            className="kc-partner-logos"
            style={{
              display: 'flex',
              gap: 56,
              alignItems: 'center',
              flexWrap: 'wrap',
            }}
          >
            {partners.map((p) => (
              <img
                key={p.name}
                src={p.logo}
                alt={p.name}
                loading="lazy"
                decoding="async"
                className="kc-partner-logo"
                style={{
                  height: 64,
                  width: 'auto',
                  objectFit: 'contain',
                }}
              />
            ))}
          </div>
        </div>
      </Container>
    </section>
  );
}
